import React, { useState, useEffect } from "react";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import Toggle from "react-toggle";
import Table from "../../components/Table";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import Toast from "../../components/Toast";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import FormInput from "../../components/FormInput";
import {
  GET_PROMOCODE_PLAN_URL,
  getData,
  deleteData,
  postData,
  putData,
  ADD_PROMOCODE,
  EDIT_PROMOCODE,
  DELETE_PROMOCODE,
} from "../../utils/api";

const PromoCode = (props) => {
  const { isCreate, setIsCreate, isFilter, setIsFilter, filter } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletePopupShown, setIsDeletePopupShown] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [itemForDelete, setItemForDelete] = useState(null);
  const [params, setParams] = useState({
    limit: 25,
    offset: 0,
    areMoreItemsAvailable: false,
  });
  const [toastParams, setToastParams] = useState({
    message: "",
    type: "",
    id: "",
  });
  const [promoCodeData, setPromoCodeData] = useState({
    code: "",
    isPercentage: false,
    value: "",
    isActive: false,
  });
  const [historyItems, setHistoryItems] = useState([]);

  useEffect(() => {
    setIsPopupShown(isCreate);
  }, [isCreate]);

  const resetData = () => {
    setPromoCodeData({
      code: "",
      isPercentage: false,
      value: "",
      isActive: false,
    });
  };

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };

  const getPromoCodeHistory = async () => {
    try {
      setIsLoading(true);
      const data = await getData(GET_PROMOCODE_PLAN_URL, {
        count: params.limit,
        offset: params.offset,
        text: filter,
      });
      setIsLoading(false);
      setHistoryItems(data.list);
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
      setIsFilter(false);
    } catch (e) {
      console.log("ERROR", e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPromoCodeHistory();
  }, [params.offset, params.text, params.limit, filter]);

  const setDelete = (item) => {
    setIsDeletePopupShown(true);
    setItemForDelete(item);
  };

  const setEdit = (item) => {
    setIsCreate(true);
    setPromoCodeData(item);
  };

  const deleteItem = async () => {
    setIsLoading(true);
    try {
      const response = await deleteData(DELETE_PROMOCODE, {
        promocodeId: itemForDelete.promocodeId,
      });
      setIsDeletePopupShown(false);
      setIsLoading(false);
      getPromoCodeHistory();
    } catch (e) {
      setToastParams({
        type: "ERROR",
        message: e && e.error ? e.error : e.response.data.error,
        id: new Date().getTime(),
      });
      setIsDeletePopupShown(false);
      setIsLoading(false);
    }
  };

  const postSubscription = async () => {
    try {
      if (
        (promoCodeData.code || "").length === 0 ||
        (promoCodeData.value || "").length === 0
      ) {
        setToastParams({
          type: "ERROR",
          message: "Fill All Details",
          id: new Date().getTime(),
        });
        return;
      }
      let data;
      if (promoCodeData?.promocodeId) {
        data = await putData(EDIT_PROMOCODE, {
          code: promoCodeData.code,
          isPercentage: promoCodeData.isPercentage,
          value: promoCodeData.value,
          isActive: promoCodeData.isActive,
          promocodeId: promoCodeData.promocodeId,
        });
      } else {
        data = await postData(ADD_PROMOCODE, { ...promoCodeData });
      }

      resetData();
      setIsLoading(false);
      setIsCreate(false);
      setToastParams({
        type: "SUCCESS",
        message:
          data &&
          data.response &&
          data.response.data &&
          data.response.data.message
            ? data.response.data.message
            : "Promo Code Successfully!",
        id: new Date().getTime(),
      });
      getPromoCodeHistory();
    } catch (e) {
      console.log("ERROR", e);
      setToastParams({
        type: "ERROR",
        message:
          e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : "Enter Valid Input",
        id: new Date().getTime(),
      });
    }
  };

  return (
    <>
      <Table
        customClassName="pr-16"
        scrollTable={true}
        columns={["Code", "Is Percentage", "Value", "Is Active", "Created"]}
        items={(historyItems || []).map((histroy) => {
          const createdDate = moment(histroy.created).format(
            "MM/DD/YYYY hh:mm A"
          );
          return {
            ...histroy,
            created: `${createdDate}`,
            isPercentageText: histroy.isPercentage ? "Yes" : "No",
            isActiveText: histroy.isActive ? "Yes" : "No",
          };
        })}
        keys={["code", "isPercentageText", "value", "isActiveText", "created"]}
        offset={params.offset}
        areMoreItemsAvailable={params.areMoreItemsAvailable}
        fetchMore={fetchMore}
        fetchLess={fetchLess}
        isLoading={isLoading}
        counterDropdown={[25, 50, 100]}
        className="min-wt-1000"
        hideCheckBox={true}
        onCountChange={(value) => {
          setParams({
            ...params,
            limit: value,
          });
        }}
        limit={params.limit}
        actions={["EDIT", "DELETE"]}
        onEdit={setEdit}
        onDelete={setDelete}
      />

      {isPopupShown && (
        <Modal>
          <div className="pt-10 pb-20 pl-10 pr-10 wt-360">
            <div className="flex flex-middle mr-12 pb-20">
              <h1
                className="mr-24 fs-20 c-black"
                style={{ fontWeight: "bold" }}
              >
                {promoCodeData?.promocodeId ? "Update" : "Add"} Promo Code
              </h1>
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                {" "}
                Code :<span className="c-red">*</span>
              </div>
              <FormInput
                className={"border-bottom-black flex-1"}
                value={promoCodeData.code}
                onChange={(e) => {
                  setPromoCodeData({
                    ...promoCodeData,
                    code: e.target.value,
                  });
                }}
              />
            </div>
            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110"> IS PERCENTAGE :</div>
              <Toggle
                className="bg-theme"
                onChange={(e) => {
                  setPromoCodeData({
                    ...promoCodeData,
                    isPercentage: e.target.checked,
                  });
                }}
                checked={promoCodeData?.isPercentage}
              />
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                Value :<span className="c-red">*</span>
              </div>

              <FormInput
                type="number"
                className={"border-bottom-black  flex-1"}
                value={promoCodeData.value}
                onChange={(e) => {
                  setPromoCodeData({
                    ...promoCodeData,
                    value: e.target.value ? Number(e.target.value) : "",
                  });
                }}
              />
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">IS ACTIVE :</div>

              <Toggle
                className="bg-theme"
                onChange={(e) => {
                  setPromoCodeData({
                    ...promoCodeData,
                    isActive: e.target.checked,
                  });
                }}
                checked={promoCodeData?.isActive}
              />
            </div>

            <div className="flex flex-middle flex-right pt-25">
              <Button
                type="modalCancel"
                className="flex flex-middle ht-40 mr-20 btn btn-red"
                onClick={() => {
                  resetData();
                  setIsCreate(false);
                }}
              >
                <span>CANCEL</span>
              </Button>
              <Button
                type="modalSave"
                className="flex  ht-40 flex-middle btn"
                onClick={postSubscription}
              >
                <span>SAVE</span>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {isDeletePopupShown && (
        <DeleteConfirmation
          type="Promocode"
          name={itemForDelete.code}
          onClose={setIsDeletePopupShown.bind(null, false)}
          onConfirm={deleteItem}
        />
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </>
  );
};

export default PromoCode;
